import Vue from 'vue'
import { API_ROOT } from '@/config'

const contextPath = 'order'

const customActions = {
  updateBulk: { method: 'PUT', url: API_ROOT + contextPath + '/bulk' }
}

export default ((<any>Vue).resource(API_ROOT + contextPath + '{/id}', {}, customActions))
